import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from './../../environments/environment';
import {UserData} from '../model/user-data';
import {UserAddRequest} from '../model/user-add-request';
import {PageableUserRequest} from '../model/pageableRequest';
import {UserUpdateRequest} from '../model/updateUserRequest';
import {UpdateUserStatusRequest} from '../model/updateUserStatus';
import {RoleCount} from '../model/roleCount';
import {PortalRolesRequest} from '../model/portal';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiUrl;
  }

  public addUser(user: UserAddRequest): Observable<any> {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');
    return this.http.post<UserAddRequest>(this.baseUrl.concat("/users/create"), user, {headers: headers});
  }

  public getUsersList(userPageableRequest: PageableUserRequest): Observable<any> {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');
    return this.http.post<UserData[]>(this.baseUrl.concat("/users/"), userPageableRequest, {headers: headers});
  }

  public updateUser(user: UserUpdateRequest) {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post<any>(this.baseUrl.concat("/users/update"), user, {headers: headers});
  }

  public updateUserStatus(user: UpdateUserStatusRequest): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post<UpdateUserStatusRequest>(this.baseUrl.concat("/users/update/status"), user, {headers: headers});
  }

  public getRoleCounts(): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get<RoleCount[]>(this.baseUrl.concat("/users/role/count").concat(), {headers: headers});
  }

  public getPortals(portalRolesRequest: PortalRolesRequest): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post<any>(this.baseUrl.concat("/users/portal/roles"), portalRolesRequest, {headers: headers});
  }

  public getRoles(): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get<any>(this.baseUrl.concat("/roles/"), {headers: headers});
  }

}
